export const balanceToUsd = (balance: number) => (
  `$${(balance / 10000).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
);